@if(!isShowingMagicLinkForm && !isShowingMagicLinkResponse) {
<div class="navigation-panel">
	<!-- The entries below all navigate away from the Search Results page, so they
		are suppressed when the restrictToSearchResultsPage feature switch is on. -->
	@if (!restrictedToSearchResults) {
		<div class="explore" (click)="emitGoHome()">
			<div class="title">
				{{ exploreTitle }}
			</div>
			<div class="highlight"></div>
		</div>
		@if (isFollowEnabled && isInternal) {
			<div class="following" (click)="emitGoToMyUpdates()">
				@if(unseenEventCount > 0) {
					<div class="count-badge">
						{{ unseenEventCount }}
					</div>
				}
				<div class="title">{{ followingTitle }}</div>
				<div class="highlight"></div>
			</div>
			<div class="preferences" (click)="emitGoToPreferences()">
				<div class="title">{{ preferencesTitle }}</div>
				<div class="highlight"></div>
			</div>
		} @if(isCompanyContact){
			<div class="profile" (click)="emitGoToCompanyUpdate(0)">
				<div class="title">{{ companyProfileTitle }}</div>
				<div class="highlight"></div>
			</div>
		} @if(isReviewer) {
			<div
				[hidden]="!isReviewer"
				class="review"
				[ngClass]="{ 'no-updates': reviews.length === 0 }"
				(click)="emitShowPendingUpdates()"
			>
				@if(updateCount > 0){
					<div class="count-badge">
						{{ updateCount }}
					</div>
				}
				<div class="title">{{ reviewTitle }}</div>
				<div class="highlight"></div>
			</div>
		}
	} @if(enableModeSwitching) {
		<div class="explore" (click)="swapMode()">
			<div class="title">
				Viewing <b>{{ mode }} Mode</b>
			</div>
		</div>
	} @if(showMagicLinkButton) {
		<div class="magic-link" (click)="showMagicLinkForm()">
			<div class="title">{{ magicLinkButtonText }}</div>
			<div class="highlight"></div>
		</div>
	}
</div>
} @if(isShowingMagicLinkForm) {
<div class="magic-link-form">
	<form>
		<div class="description">{{ magicLinkDescription }}</div>
		<div class="inputs">
			<input
				#email
				[(ngModel)]="emailAddress"
				type="email"
				id="emailAddress"
				name="emailAddress"
				required
			/>
			<input
				class="button"
				type="submit"
				[disabled]="!email.validity.valid"
				value="{{
					email.validity.valid
						? Loc(LocalizedTextIds.Submit)
						: Loc(LocalizedTextIds.EnterAValidEmail)
				}}"
				(click)="sendMagicLink()"
			/>
		</div>
	</form>
</div>
} @else if (isShowingMagicLinkResponse){
<div class="magic-link-response" (click)="dismissMagicLinkResponse()">
	{{ magicLinkMessage }}
</div>
}
